import { ElMessage } from 'element-plus'

/**
 * 前端错误监控工具
 */
class ErrorMonitor {
  constructor() {
    this.errorCount = 0
    this.maxErrors = 10
    this.errorWindow = 60000 // 1分钟内的错误窗口
    this.lastErrorTime = 0
    
    this.init()
  }

  init() {
    // 监听全局错误
    window.addEventListener('error', this.handleGlobalError.bind(this))
    
    // 监听Promise错误
    window.addEventListener('unhandledrejection', this.handlePromiseError.bind(this))
    
    // 监听Vue错误
    if (window.Vue) {
      window.Vue.config.errorHandler = this.handleVueError.bind(this)
    }
  }

  handleGlobalError(event) {
    this.logError('Global Error', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error
    })
  }

  handlePromiseError(event) {
    this.logError('Promise Error', {
      reason: event.reason,
      promise: event.promise
    })
  }

  handleVueError(error, vm, info) {
    this.logError('Vue Error', {
      error: error.message,
      component: vm?.$options?.name || 'Unknown',
      info: info
    })
  }

  logError(type, details) {
    const now = Date.now()
    
    // 检查错误频率
    if (now - this.lastErrorTime < this.errorWindow) {
      this.errorCount++
    } else {
      this.errorCount = 1
      this.lastErrorTime = now
    }

    console.error(`[${type}]`, details)
    
    // 如果错误过多，显示警告
    if (this.errorCount >= this.maxErrors) {
      this.showErrorWarning()
    }
  }

  showErrorWarning() {
    ElMessage({
      message: '系统检测到较多错误，请刷新页面或联系管理员',
      type: 'warning',
      duration: 0,
      showClose: true
    })
  }

  // 手动记录错误
  recordError(error, context = '') {
    this.logError('Manual Error', {
      error: error.message || error,
      context,
      stack: error.stack
    })
  }

  // 获取错误统计
  getErrorStats() {
    return {
      errorCount: this.errorCount,
      lastErrorTime: this.lastErrorTime,
      timeSinceLastError: Date.now() - this.lastErrorTime
    }
  }

  // 重置错误计数
  resetErrorCount() {
    this.errorCount = 0
    this.lastErrorTime = 0
  }
}

// 创建全局实例
const errorMonitor = new ErrorMonitor()

export default errorMonitor
